import { type FeatureFlags } from '@contra/feature-flags';
import { type PostHog } from 'posthog-js';
import { createContext, type MutableRefObject } from 'react';

export type PostHogContext = {
  featureFlags: Readonly<Partial<FeatureFlags>>;
  featureFlagsLoaded: boolean;
  posthogInstance: null | PostHog;
  setFeatureFlags: (flags: Readonly<Partial<FeatureFlags>>) => void;
  warnings?: MutableRefObject<string[]>;
};

export const PostHogContext = createContext<null | PostHogContext>(null);
